import React, { useState, useEffect } from "react";
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import "../../../../styles/pages-styles/main-dashboard-pages-styles/question-pages-styles/exam-pages-styles/MockExamsQuestions.css";
import axios from "axios";
import { useNavigate } from 'react-router-dom';

const MockExamsQuestions = () => {
    const [examQuestions, setExamQuestions] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [userAnswers, setUserAnswers] = useState({});
    const [timeRemaining, setTimeRemaining] = useState(3 * 60 * 60); // 3 hours in seconds
    const questionsPerPage = 1;
    const userId = sessionStorage.getItem("userId");
    // const userId = "67ebab9b5ef550de19850627"; // Replace with actual user ID
    const navigate = useNavigate();
    const optionKeys = ["A", "B", "C", "D"]; // Array of option keys

    const fetchQuestions = async () => {
        try {
            const response = await axios.get(`/user/fetch-exam-questions?page=${currentPage - 1}&limit=${questionsPerPage}`);
            if (response.status === 200) {
                // Ensure options have a key if they don't already
                const formattedQuestions = response.data.examQuestions.map(question => ({
                    ...question,
                    options: question.options.map((option, index) => ({
                        ...option,
                        key: option.key || optionKeys[index], // Use existing key or assign one
                    })),
                }));
                setExamQuestions(formattedQuestions);
                setTotalPages(response.data.totalPages);
            }
        } catch (error) {
            console.error("Error fetching questions:", error);
        }
    };

    const handleOptionChange = (questionId, selectedAnswerKey) => {
        setUserAnswers({
            ...userAnswers,
            [questionId]: selectedAnswerKey, // Store the option key (A, B, C, D)
        });
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleSubmitExam = async () => {
        const answers = Object.keys(userAnswers).map((questionId) => ({
            questionId,
            selectedAnswer: userAnswers[questionId], // Send the option key (A, B, C, D)
        }));

        try {
            const response = await axios.post("/user/submit-exam-question", {
                answers,
                userId,
            });

            if (response.status === 200) {
                navigate('/exam-results', { state: response.data });
            }
        } catch (error) {
            console.error("Error submitting exam:", error);
        }
    };

    useEffect(() => {
        fetchQuestions();
    }, [currentPage]);

    useEffect(() => {
        fetchQuestions();
    }, []);

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeRemaining(prevTime => prevTime - 1);
        }, 1000);

        if (timeRemaining <= 0) {
            clearInterval(timer);
            handleSubmitExam();
        }

        return () => clearInterval(timer);
    }, [timeRemaining]);

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            const message = "Refreshing the page will submit the exam automatically. Are you sure?";
            const confirmation = window.confirm(message);
            if(confirmation){
                handleSubmitExam()
            }
            else{
                event.preventDefault();
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, []);

    const formatTime = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    };

    return (
        <div className="exam-container">
            {/* Navbar */}
            <Navbar expand="lg" className="bg-body-primary">
                <Container>
                    <Navbar.Brand href="#home">PassMedicine</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            <NavDropdown title="Options" id="basic-nav-dropdown">
                                <NavDropdown.Item href="#action/3.2">
                                    Save and Exit
                                </NavDropdown.Item>
                                <NavDropdown.Item href="#action/3.3">
                                    Abandon and Exit
                                </NavDropdown.Item>
                            </NavDropdown>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            {/* Header */}
            <header className="exam-header">
                <div className="exam-header-item">Calculator</div>
                <div className="exam-header-item">Time Remaining {formatTime(timeRemaining)}</div>
                <div className="exam-header-item">
                    {currentPage} of {totalPages}
                </div>
                <div className="exam-header-item">Flag for Review</div>
            </header>

            {/* Main Content */}
            <main className="exam-content">
                {examQuestions && examQuestions.length > 0 ? (
                    examQuestions.map((question, index) => (
                        <div key={index} className="exam-grid">
                            <div className="exam-scenario">
                                <p>{question?.questionText}</p>
                            </div>

                            <div className="exam-options">
                                {question?.options.map((option, idx) => (
                                    <div key={idx} className="exam-option">
                                        <input
                                            type="radio"
                                            name={`question-${question._id}`}
                                            value={option.key} // Set value to the option key (A, B, C, D)
                                            checked={userAnswers[question._id] === option.key}
                                            onChange={() => handleOptionChange(question._id, option.key)}
                                        />
                                        <label>{option.value}</label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))
                ) : (
                    <p>Loading questions...</p>
                )}
            </main>

            {/* Footer - Pagination Controls */}
            <footer className="exam-footer">
                <button
                    className="next-button"
                    onClick={handlePrevious}
                    disabled={currentPage === 1}
                >
                    ← Previous
                </button>
                {currentPage === totalPages ? (
                    <button className="exam-submit-button" onClick={handleSubmitExam}>
                        Submit Exam
                    </button>
                ) : (
                    <button className="next-button" onClick={handleNext}>
                        Next →
                    </button>
                )}
            </footer>
        </div>
    );
};

export default MockExamsQuestions;